import { string } from 'prop-types';
import React from 'react';

import SvgIcon from 'ravenjs/lib/SvgIcon';

const OutOfOfficeIcon = ({ ...rest }) => (
    <SvgIcon {...rest}>
        <path
            fill="currentColor"
            d="M1600 1024q26 0 45 19t19 45t-19 45t-45 19t-45-19t-19-45t19-45t45-19m-832 256h128v768H768zM1920 0v2048h-128V128H896v768H768V0zM347 1024h805v128H347l210 211l-90 90l-365-365l365-365l90 90z"
        />
    </SvgIcon>
);

OutOfOfficeIcon.propTypes = {
    viewBox: string,
    width: string,
    height: string,
};

OutOfOfficeIcon.defaultProps = {
    height: '50',
    viewBox: '0 0 2048 2048',
    width: '50',
};

export default OutOfOfficeIcon;
